<template>
    <div class="sld_login">
        <div class="sld_login_header">
            <div class="content">
                <router-link tag="a" class="l_logo" :to="`/index`">
                    <img class='img' :src="configInfo.main_register_site_logo" :onerror='defaultImg' alt />
                </router-link>
                <div class="r_register_wrap">
                    {{ L['已有账号？'] }}
                    <a href="javascript:void(0)" class="go_register_btn" @click="goToPage('/login')">
                        {{ L['去登录'] }}
                    </a>
                </div>
            </div>
        </div>
        <div class="sld_login_content">
            <img class="bg" :src="configInfo.main_user_register_bg" :onerror='defaultBgImg' alt />
            <div class="login">
                <div class="login_box">
                    <div class="top">
                        <div class="item1">{{ L['注册账号'] }}</div>
                    </div>
                    <div class="center">
                        <div class="item account">
                            <input type="text" v-model="companyName" placeholder="请输入单位全称" class="input"
                                @focus="showClose('companyName')">
                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"
                                    v-show="companyName && current == 'companyName'"
                                    @click="delateInput('companyName')"></span>
                            </div>
                        </div>
                         <div class="item account">
                            <input type="text" v-model="user_name" placeholder="请输入姓名" class="input"
                                @focus="showClose('user_name')">
                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"
                                    v-show="user_name && current == 'user_name'"
                                    @click="delateInput('user_name')"></span>
                            </div>
                        </div>
                         <div class="item account">
                            <input type="text" v-model="Email" placeholder="请输入邮箱" class="input"
                                @focus="showClose('Email')">
                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"
                                    v-show="Email && current == 'Email'"
                                    @click="delateInput('Email')"></span>
                            </div>
                        </div>
                        <div class="item account">
                            <!-- <span style="color: #BBB;font-size: 21px;padding-top: 7px"
                                class="icon iconfont icon-shouji2"></span> -->
                            <!-- <input type="text" v-model="addressAll" placeholder="请选择所在地" class="input"  @focus="showClose('addressAll')"> -->
                            <!-- <el-cascader ref="cascaderAddr" v-model="addressAll" :options="areaDataArray" class="item_cascader"
                                :placeholder="L['请选择所在地区']" :props="cascaderProps" clearable></el-cascader> -->
					<el-cascader ref="cascaderAddr" v-model="addressAll" :options="areaDataArray" :placeholder="L['请选择所在地区']" :props="cascaderProps"
						clearable  @expand-change="expandChange"></el-cascader>

                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"
                                    v-show="addressAll && current == 'addressAll'"
                                    @click="delateInput('addressAll')"></span>
                            </div>
                        </div>
                        <div class="item account">
                            <!-- <span style="color: #BBB;font-size: 21px;padding-top: 7px"
                                class="icon iconfont icon-shouji2"></span> -->
                            <input type="text" v-model="detailAddress" placeholder="请输入详细地址" class="input"
                                @focus="showClose('detailAddress')">
                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu"
                                    v-show="detailAddress && current == 'detailAddress'"
                                    @click="delateInput('detailAddress')"></span>
                            </div>
                        </div>
                        <div class="item account">
                            <!-- <span style="color: #BBB;font-size: 21px;padding-top: 7px"
                                class="icon iconfont icon-shouji2"></span> -->
                            <input type="text" v-model="name" :placeholder="L['请输入手机号']" class="input"
                                @focus="showClose('name')">
                            <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                                <span style="color: #bbb;" class=" iconfont icon-cuowu" v-show="name && current == 'name'"
                                    @click="delateInput('name')"></span>
                            </div>
                        </div>

                        <div class="item password">
                        <!-- <span style="color: #BBB;font-size: 18px;padding-top: 8px"
                            class="icon iconfont icon-mima"></span> -->
                        <input type="password" v-model="loginPassword" :placeholder="L['请输入登录密码']" class="input"
                            @focus="showClose('loginPassword')">
                        <div data-type="password" class="cancel" @click="clearInputVal('password')">
                            <span style="color: #bbb;" class=" iconfont icon-cuowu" 
                                v-show="loginPassword && current == 'loginPassword'"
                                @click="delateInput('loginPassword')"></span>
                        </div>
                    </div>

                    <div class="item password">
                    <!-- <span style="color: #BBB;font-size: 18px;padding-top: 8px"
                        class="icon iconfont icon-mima"></span> -->
                    <input type="password" v-model="confirmPassword" :placeholder="L['请确认登录密码']" class="input"
                        @focus="showClose('confirmPassword')">
                    <div data-type="confirmPassword" class="cancel" @click="clearInputVal('confirmPassword')">
                        <span style="color: #bbb;" class=" iconfont icon-cuowu" 
                            v-show="confirmPassword && current == 'confirmPassword'"
                            @click="delateInput('confirmPassword')"></span>
                    </div>
                </div>

                        <!-- <div class="item password"> -->
                            <!-- <span style="color: #BBB;font-size: 18px;padding-top: 8px"
                                class="icon iconfont icon-yanzhengma2"></span> -->
                            <!-- <input type="text" v-model="imgCode" :placeholder="L['请输入图形验证码']" class="input">
                            <img :src="showCodeImg" class="img_code" @click="getImgCode" />
                        </div> -->
                        <div class="item password">
                            <!-- <span style="color: #BBB;font-size: 18px;padding-top: 8px"
                                class="icon iconfont icon-yanzhengma2"></span> -->
                            <input type="text" v-model="password" :placeholder="L['请输入验证码']" class="input">
                            <a href="javascript:void(0);" class="send_code"
                                @click="getSmsCode">{{ countDownM ? (countDownM + L['s后获取']) : L['获取验证码'] }}</a>
                        </div>
                        <div class="error">
                            <span v-if="errorMsg" style="color: #e1251b;font-size: 14px" class="iconfont icon-jubao"></span>
                            {{ errorMsg }}
                        </div>
                        <a href="javascript:void(0)" @click="login" class="login_btn">{{ L['立即注册'] }}</a>
                        <div class="agree_wrap">
                              <div class="agree_item">
                                <input type="checkbox" 
                                    id="userAgreement" 
                                    :class="{ checkbox: true, checked: agreeUserAgreement }" 
                                    v-model="agreeUserAgreement"
                                    @click.stop="openUserAgreement" />
                                <label for="userAgreement" class="agree_label">
                                <span class="agree_selected"></span>
                                <span class="text">
                                    {{ L['我同意'] }}
                                    <a href="javascript:void(0)" class="agreement" @click.stop="openUserAgreement">
                                    {{ L['《用户注册协议》'] }}
                                    </a>
                                </span>
                                </label>
                            </div>
                            
                            <div class="agree_item">
                                <input type="checkbox" 
                                    id="privacyPolicy" 
                                    :class="{ checkbox: true, checked: agreePrivacyPolicy }" 
                                    v-model="agreePrivacyPolicy"
                                    @click.stop="openPrivacyPolicy" />
                                <label for="privacyPolicy" class="agree_label">
                                <span class="agree_selected"></span>
                                <span class="text">
                                    {{ L['我同意'] }}
                                    <a href="javascript:void(0)" class="agreement" @click.stop="openPrivacyPolicy">
                                    {{ L['《隐私政策》'] }}
                                    </a>
                                </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div :class="{ bottom: true, flex_row_between_center: wxEnable == 1, flex_row_end_center: wxEnable != 1 }">
                        <img v-if="wxEnable == 1" src="@/assets/wechat_login.png" alt="" @click="wetChatLogin">
                        <a href="javascript:void(0)" @click="goToPage('/login')">{{ L['已有账号，去登录'] }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

<AgreementModal 
 :visible="showAgreementModal"
  :type="currentAgreementType"
  :title="agreementTitle"
  :content="agreementContent"
  @confirm="handleAgreementConfirm"
  @cancel="handleAgreementCancel"/>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { ref, getCurrentInstance, onMounted, watch,nextTick,onUnmounted } from 'vue';
import { useStore } from 'vuex';
import areaData from "../../../assets/area.json";
import md5 from '@/utils/md5.js';
import { Base64 } from 'js-base64'
import { h5CaptchaAppId } from "../../../utils/config"
import AgreementModal from '@/components/AgreementModal.vue';
export default {
    name: "Register",
    components: {
        AgreementModal
    },
    setup() {
        const store = useStore();
        const route = useRoute()
        // const agreeFlag = ref(false);//同意注册协议标识，默认不同意
        const companyName = ref('');//单位名称
        const addressAll = ref('');//所在地
        const cascaderProps = { label: "regionName", value: "regionCode" };
        const detailAddress = ref('');//详细地址
        const provinceCode = ref('');//省市编码
        const cityCode = ref('');//城市编码
        const districtCode = ref('');//地区编码
        const name = ref('');//手机号
        const errorMsg = ref();//错误提示
        const password = ref('');//密码
        const imgCode = ref('');//图形验证码
        const router = useRouter();
        const { proxy } = getCurrentInstance();
        const L = proxy.$getCurLanguage();
        const countDownM = ref(0);//短信验证码倒计时
        const timeOutId = ref('');//定时器的返回值
        const showCodeImg = ref('');//图形验证码图片
        const imgCodeKey = ref('');//图形验证码的key
        const configInfo = ref(store.state.configInfo)
        const defaultImg = ref('this.src="' + require('../../../assets/common_top_logo.png') + '"')
        const defaultBgImg = ref('this.src="' + require('../../../assets/login_bg.png') + '"')
        const preventFre = ref(false)
        const wxEnable = ref("");
        const pcAppid = ref("");
        const fromurl = ref('');
        const  user_name = ref('');
        const  Email = ref('');
        const current = ref('');
        const cascaderAddr = ref(null);
        const areaDataArray = areaData;
        const captchaInstance = ref(null);

        const agreeUserAgreement = ref(false);  // 用户注册协议勾选状态
        const agreePrivacyPolicy = ref(false);  

        const showAgreementModal = ref(false);
    const currentAgreementType = ref(1); // 1: 用户注册协议, 2: 隐私政策
    const agreementContent = ref('');
    const agreementTitle = ref('');
    const loginPassword = ref(''); // 新增：登录密码
    const confirmPassword = ref(''); // 确认密码

    
    // 获取协议内容
    const fetchAgreementContent = (type) => {
      const agreementCode = type == 1 ? 'register_agreement' : 'privacy_policy';
      proxy.$get('v3/system/front/agreement/detail', { agreementCode }).then(res => {
        if (res.state == 200) {
          agreementContent.value = proxy.$quillEscapeToHtml(res.data.content);
          agreementTitle.value = res.data.title;
        }
      });
    };
    
    // 显示协议模态框
    const showAgreement = (type) => {
      currentAgreementType.value = type;
      fetchAgreementContent(type);
      showAgreementModal.value = true;
    };
    
    // 处理协议确认
    const handleAgreementConfirm = () => {
      if (currentAgreementType.value === 1) {
        agreeUserAgreement.value = true;
      } else if (currentAgreementType.value === 2) {
        agreePrivacyPolicy.value = true;
      }
      showAgreementModal.value = false;
    };
    
    // 处理协议取消
    const handleAgreementCancel = () => {
      if (currentAgreementType.value === 1) {
        agreeUserAgreement.value = false;
      } else if (currentAgreementType.value === 2) {
        agreePrivacyPolicy.value = false;
      }
      showAgreementModal.value = false;
    };
    
    // 修改协议链接的点击事件
    const openUserAgreement = () => {
        if (!agreeUserAgreement.value) {
            showAgreement(1);
        }
    };

    const openPrivacyPolicy = () => {
        if (!agreePrivacyPolicy.value) {
            showAgreement(2);
        }
    };


        // 微信二维码注册
        const wetChatLogin = () => {
            let href = `https://open.weixin.qq.com/connect/qrconnect?appid=${pcAppid.value}&redirect_uri=${encodeURIComponent(fromurl.value)}&response_type=code&scope=snsapi_login&state=2or3m#wechat_redirect`
            window.open(href, "_blank")
        }
        const getWxEnbale = () => {
            proxy.$get('v3/system/front/setting/getSettings', { names: 'login_wx_pc_is_enable,login_wx_pc_appid,main_user_register_bg,main_register_site_logo' }).then(res => {
                if (res.state == 200) {
                    wxEnable.value = res.data[0]
                    pcAppid.value = res.data[1]
                    configInfo.value.main_user_register_bg = res.data[2]
                    configInfo.value.main_register_site_logo = res.data[3]
                }
            })
        }

        const login = () => {
            // 验证
            if (!companyName.value) return errorMsg.value = '请输入单位全称';
            if (!addressAll.value) return errorMsg.value = '请选择所在地区';
            if (!detailAddress.value) return errorMsg.value = '请输入详细信息';

        // 新增：验证登录密码和确认密码
        const passwordValidation = validatePassword(loginPassword.value, confirmPassword.value);
        if (passwordValidation !== true) {
            return errorMsg.value = passwordValidation;
        }

            let param = {};
            param.memberTrueName = user_name.value;
            param.memberEmail = Email.value;
            param.phone = name.value;
            param.code = password.value;
            param.verifyCode = imgCode.value;
            param.verifyKey = imgCodeKey.value;
            param.companyName = companyName.value;
            param.detailAddress = detailAddress.value;
            param.addressAll = cascaderAddr.value.getCheckedNodes()[0].pathLabels.join("");
            param.provinceCode = addressAll.value[0];
            param.cityCode = addressAll.value[1];
            param.districtCode = addressAll.value[2];
            param.source = 1
            param.loginPwd = loginPassword.value; // 新增：添加密码到参数中

            //手机号验证
            if (!param.phone) {
                errorMsg.value = L['请输入手机号'];
                return false;
            } else {
                let checkMobile = proxy.$checkPhone(param.phone);
                if (checkMobile != true) {
                    errorMsg.value = checkMobile;
                    return false;
                }
            }

            //验证码校验
            if (!param.code) {
                errorMsg.value = L['请输入短信验证码'];
                return false;
            } else {
                let checkSmsCode = proxy.$checkSmsCode(param.code);
                if (checkSmsCode !== true) {
                    errorMsg.value = checkSmsCode;
                    return false;
                }
            }

            if (!agreeUserAgreement.value || !agreePrivacyPolicy.value) {
                errorMsg.value = L['请同意用户注册协议及隐私政策'];
                return false;
            }

            //如果未登录vuex中有购物车数据，需同步到该用户
            let cartInfo = [];
            let cartListData = store.state.cartListData;
            if (JSON.stringify(cartListData) != '{}') {
                // cartListData.storeCartGroupList.map(cartListItem => {
                //     cartListItem.promotionCartGroupList.map(promotItem => {
                //         promotItem.cartList.map(cartItem => {
                //             cartInfo.push({
                //                 productId: cartItem.productId,
                //                 buyNum: cartItem.buyNum
                //             })
                //         })
                //     })
                // })
                cartListData.promotionCartGroupList.map(promotItem => {
                        promotItem.cartList.map(cartItem => {
                            cartInfo.push({
                                productId: cartItem.productId,
                                buyNum: cartItem.buyNum
                            });
                        });
                });
            }
            param.cartInfo = JSON.stringify(cartInfo);

            proxy.$post('v3/frontLogin/front/oauth/register', param).then(res => {
                if (res.state == 200) {
                    //将用户信息存缓存，并跳转到首页
                    localStorage.setItem('access_token', res.data.access_token);
                    localStorage.setItem('refresh_token', res.data.refresh_token);
                    localStorage.setItem('time', new Date().getTime().toString());//存储refresh_token更新时间
                    //获取用户信息，并同步信息到vuex
                    proxy.$get('v3/member/front/member/getInfo').then(res => {
                        if (res.state == 200) {
                            //清空购物车store
                            proxy.$sldStatEvent({ behaviorType: 'reg' })
                            store.commit('updateCartListData', {});
                            store.commit('updateMemberInfo', res.data);
                            router.back();
                        }
                    })
                } else {
                    //提示错误
                    getImgCode();
                    errorMsg.value = res.msg
                }
            })
        }
        //清空输入框内容
        const clearInputVal = (type) => {
            if (type == 'name') {
                name.value = '';
            } else if (type == 'password') {
                password.value = '';
            } else if (type == 'loginPassword') { // 新增
                loginPassword.value = '';
            } else if (type == 'confirmPassword') { // 新增
                confirmPassword.value = '';
            }
        }

        // 验证密码格式：至少8位，必须包含英文大小写、数字
        const validatePassword = (password) => {
            if (!password) {
                return '请输入登录密码';
            }
            if (password.length < 8) {
                return '密码长度至少8位';
            }

            let checkPwd = proxy.$checkPwd(password);
				console.log(checkPwd, password)
			if (checkPwd !== true) {
				return checkPwd;
			}

            const hasUpperCase = /[A-Z]/.test(password);
            const hasLowerCase = /[a-z]/.test(password);
            const hasNumber = /\d/.test(password);
            
            if (!hasUpperCase || !hasLowerCase || !hasNumber) {
                return '密码必须包含大写字母、小写字母和数字';
            }

            // 验证确认密码
            if (!confirmPassword.value) {
                return '请确认登录密码';
            }
            
            if (password !== confirmPassword.value) {
                return '两次输入的密码不一致';
            }
            return true;
        }

        //获取短信验证码
        const getSmsCode = () => {
            if (preventFre.value) {
                return;
            } else if (countDownM.value) {
                return;
            }
            preventFre.value = true
            let checkMobile = proxy.$checkPhone(name.value);
            // let checkImgCode = proxy.$checkImgCode(imgCode.value);
            if (checkMobile !== true) {
                errorMsg.value = checkMobile;
                preventFre.value = false;
                return false
            } 
            showCaptcha()
            return 
            if (checkImgCode !== true) {
                errorMsg.value = checkImgCode;
                preventFre.value = false;
            } else {
                let param = {};
                param.mobile = name.value;
                // param.verifyType = 2;
                param.verifyCode = imgCode.value;
                param.verifyKey = imgCodeKey.value;
                let bytes = Base64.encode(Base64.encode(name.value))
                bytes = bytes.substring(0, bytes.length - 2)
                let code = md5.hex_md5(imgCode.value)
                param.verifyStr = bytes+code
                proxy.$get('v3/msg/front/commons/getCaptcha', param).then(res => {
                    if (res.state == 200) {
                        countDownM.value = 60;
                        countDown();
                        preventFre.value = false;
                    } else {
                        //提示错误
                        getImgCode();
                        errorMsg.value = res.msg
                        preventFre.value = false;
                    }
                })
            }
        }
        //倒计时
        const countDown = () => {
            countDownM.value--;
            if (countDownM.value == 0) {
                preventFre.value = false
                clearTimeout(timeOutId.value);
            } else {
                timeOutId.value = setTimeout(countDown, 1000);
            }
        }
        //获取图形验证码
        const getImgCode = () => {
            proxy.$get('v3/captcha/common/getCaptcha', {}).then(res => {
                if (res.state == 200) {
                    showCodeImg.value = 'data:image/png;base64,' + res.data.captcha;
                    imgCodeKey.value = res.data.key;
                }
            })
        }
        // //是否同意用户注册协议
        // const agree = () => {
        //     agreeFlag.value = !agreeFlag.value;
        // }

        //通过replace方式跳转页面
        const goToPage = (type) => {
            router.replace({
                path: type,
            });
        }

        watch([name, imgCode, password, loginPassword, confirmPassword], () => {
            password.value = password.value.substring(0, 20)
            imgCode.value = imgCode.value.substring(0, 4)
            name.value = name.value.substring(0, 11)
            loginPassword.value = loginPassword.value.substring(0, 20)
            confirmPassword.value = confirmPassword.value.substring(0, 20)
            if (password.value || imgCode.value || name.value|| loginPassword.value || confirmPassword.value) {
                errorMsg.value = ''
            }
        })

		const expandChange = (e) => {
			nextTick(() => {
				const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node');
				Array.from($el).map((item) => item.removeAttribute('aria-owns'));
			})
		}


        onMounted(() => {
            loadCaptchaScript()
            getWxEnbale()
            if (route.query.redirectUrl) {
                fromurl.value = window.location.origin + decodeURIComponent(route.query.redirectUrl)
            } else {
                fromurl.value = window.location.origin
            }
            nextTick(() => {
				const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node');
				Array.from($el).map((item) => item.removeAttribute('aria-owns'));
			})
            getImgCode(); //获取图形验证码
            document.body.classList.remove('el-popup-parent--hidden');
        })

        const showClose = (cur) => {
            current.value = cur
        }
        const delateInput = (type) => {
            switch (type) {
                case 'companyName':
                    companyName.value = '';
                    break;
                case 'addressAll':
                    addressAll.value = '';
                    break;
                case 'detailAddress':
                    detailAddress.value = '';
                    break;
                case 'name':
                    name.value = '';
                    break;
                case 'loginPassword': // 新增
                    loginPassword.value = '';
                    break;
                case 'confirmPassword': // 新增
                    confirmPassword.value = '';
                    break;
            }
        }
        
            const loadCaptchaScript = () => {
                return new Promise((resolve, reject) => {
                    // 检查脚本是否已加载
                    if (window.TencentCaptcha) {
                        resolve();
                        return;
                    }

                    // 创建script标签加载验证码脚本
                    const script = document.createElement('script');
                    script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js';
                    script.type = 'text/javascript';
                    script.onload = resolve;
                    script.onerror = () => reject(new Error('验证码脚本加载失败'));
                    document.head.appendChild(script);
                });
            }
            const showCaptcha = () => {
                return new Promise((resolve, reject) => {
                    // 创建验证码实例
                    captchaInstance.value = new window.TencentCaptcha(
                        h5CaptchaAppId,
                        (res) => {
                            // 验证码回调结果处理
                            if (res.ret === 0) {
                                // 验证成功，获取ticket和randstr
                                verifyWithServer(res.ticket, res.randstr)
                                    .then(res => {
                                        resolve(res)
                                    })
                                    .catch(err => {
                                        reject(err)
                                    });
                            } else {
                                console.log(res, '1111111')
                                // 验证失败
                                reject(new Error(getErrorMsg(res.ret)));
                            }
                        }, {
                        // 验证码配置
                        type: 'popup', // 嵌入式展示
                        container: 'captchaContainer', // 容器ID
                        theme: 'white', // 主题
                        lang: 'zh-cn', // 语言
                        showFn: (ret) => {
                            console.log('showFn', ret)
                        }
                    }
                    );

                    // 显示验证码
                    captchaInstance.value.show();
                });
            }
            const verifyWithServer = (ticket, randstr) => {
                let param = {};
                param.mobile = name.value;
                param.type = "free";
                param.ticket = ticket;
                param.randstr = randstr;
                proxy.$get('v3/msg/front/commons/getCaptcha', param).then(res => {
                    if (res.state == 200) {
                        countDownM.value = 60;
                        countDown();
                        preventFre.value = false;
                    } else {
                        //提示错误
                        getImgCode();
                        errorMsg.value = res.msg
                        preventFre.value = false;
                    }
                })
            }
            onUnmounted(() => {
                if (captchaInstance.value) {
                    captchaInstance.value.destroy()
                }
            })
        return {
			expandChange,
            L,
            login,
            name,
            password,
            loginPassword,
            confirmPassword,
            clearInputVal,
            errorMsg,
            getSmsCode,
            countDownM,
            imgCode,
            showCodeImg,
            imgCodeKey,
            getImgCode,
            // agreeFlag,
            // agree,
            goToPage,
            configInfo,
            defaultImg,
            defaultBgImg,
            wxEnable,
            pcAppid,
            fromurl,
            wetChatLogin,
            getWxEnbale,

            companyName,
            addressAll,
            detailAddress,
            provinceCode,
            cityCode,
            districtCode,
            current,
            showClose,
            delateInput,
            cascaderProps,
            areaDataArray,
            cascaderAddr,
            Email,
            user_name,
            captchaInstance,
            loadCaptchaScript,
            showCaptcha,
            agreeUserAgreement,
            agreePrivacyPolicy,
            verifyWithServer,
            showAgreementModal,
            agreementContent,
            agreementTitle,
            showAgreement,
            handleAgreementConfirm,
            handleAgreementCancel,
            openUserAgreement,
            openPrivacyPolicy
            
        };
    },
};
</script>
<style lang="scss" scoped>
@import '../../../style/register.scss';
:deep(.item_cascader) { 
    height: 30px !important;
    margin-top: -10px !important;
}
.el-popup-parent--hidden {
    overflow: visible;
}
// .agree_item {
//   display: flex;
//   align-items: center;
//   margin-bottom: 10px;
  
//   .agree_label {
//     display: flex;
//     align-items: center;
//     cursor: pointer;
//   }
  
//   .text {
//     margin-left: 8px;
    
//     .agreement {
//       color: #409eff;
//       text-decoration: none;
      
//       &:hover {
//         text-decoration: underline;
//       }
//     }
//   }
  
//   input[type="checkbox"] {
//     display: none;
//   }
  
//   .agree_selected {
//     cursor: pointer;
//     position: relative;
//     width: 14px;
//     height: 14px;
    
//     &:before {
//       content: '';
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       border: 1px solid #ddd;
//       background: #fff;
//     }
    
//     &:after {
//       content: '';
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%) scale(0);
//       width: 8px;
//       height: 8px;
//       background: #409eff;
//       transition: transform 0.2s;
//     }
//   }
  
//   input:checked + .agree_label .agree_selected {
//     &:after {
//       transform: translate(-50%, -50%) scale(1);
//     }
//   }
// }
</style>